var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8326 7C15.1838 7 18.0756 9.66074 19.6466 11.9983C18.884 13.1193 17.7434 14.3784 16.3765 15.3539C14.9864 16.3459 13.4273 17 11.8326 17C10.2379 17 8.67876 16.3459 7.28875 15.3539C5.92249 14.3789 4.78239 13.1206 4.01981 12C4.78239 10.8794 5.92249 9.62112 7.28875 8.64607C8.67876 7.65407 10.2379 7 11.8326 7ZM20.512 11.4934C20.7166 11.8009 20.7167 12.1992 20.5106 12.5057C18.8694 14.9458 15.5691 18 11.8326 18C8.09605 18 4.79581 14.9458 3.15458 12.5057C2.94847 12.1992 2.94847 11.8008 3.15458 11.4943C4.79581 9.05415 8.09605 6 11.8326 6C15.7176 6 18.8882 9.05341 20.512 11.4934ZM11.8326 16C14.0417 16 15.8326 14.2091 15.8326 12C15.8326 9.79086 14.0417 8 11.8326 8C9.62347 8 7.83261 9.79086 7.83261 12C7.83261 14.2091 9.62347 16 11.8326 16Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eyeOpen.093f70bb54e09d877614d918e8598b7b.svg";
export { ForwardRef as ReactComponent };